<div [formGroup]="form" class="input-group mb-3">
  <span class="input-group-text" id="basic-addon1"
    ><i class="fa-solid fa-lock"></i></span>
  <input
    #ipt
    [type]="typeInput"
    id="input"
    (change)="selected(ipt)"
    (keyup)="selected(ipt)"
    formControlName="input"
    class="{{ class }}"
  />
  <button *ngIf="typeInput!='text'" type="button" class="btn btn-outline-secondary" (click)="typeInput='text'"><i class="fa-regular fa-eye"></i></button>
  <button *ngIf="typeInput!='password'" type="button" class="btn btn-outline-secondary" (click)="typeInput='password'"><i class="fa-regular fa-eye-slash"></i></button>
  <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="openModal(generate)">
    <i class="fa-solid fa-key"></i
        > Generar
  </button>
</div>

<ng-template #generate let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-password-generate (result)="passGenerete=$event"/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
        <button type="button" class="btn btn-primary" (click)="d('Cross click')" aria-label="Close" (click)="usePass()"> Usar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
  </ng-template>